import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Import once so FA's autoAddCss=false side effect runs before any
// FontAwesomeIcon render anywhere in the app.
import "@/lib/icons";
// Must run before any component calls useTranslation.
import "@/i18n";
import { initSentry } from "@/lib/sentry";
import { App } from "./App";
import "./styles/globals.css";

initSentry();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
